module.exports = __webpack_public_path__ + "static/img/content-bg.0cdc4dd1.jpg";